export default __webpack_public_path__ + "static/media/mision.6e3b628b.png";